// extracted by mini-css-extract-plugin
module.exports = {"container":"G8ZHCCJX","containerSm":"_3k4hULTZ","detailsWrapper":"_3XB3jrcA","details":"_1GK-Cr9V"};